<template>
    <div class="row content">
        <div class="item d-flex">
            <div class="col-12 align-self-center text-center">
                <div class="item_tit animate">
                    <h1 class="animated bounceIn">
                        Seja bem-vindo, {{Name()}}
                    </h1>
                    <p class="animated bounceIn">
                        Escolha o que mais se adequa a sua realidade.
                    </p>
                </div>
                <div class="row justify-content-center">
                    <div class="col-10 animate">
                        <ul class="row justify-content-center">
                            <li class="col-12 col-md-4 animated fadeInDown">
                                <a href="">
                                    Emprestimo
                                </a>
                            </li>
                            <li class="col-12 col-md-4 animated fadeInDown">
                                <a href="">
                                    Investimento
                                </a>
                            </li>
                            <li class="col-12 col-md-4 animated fadeInDown">
                                <a href="">
                                    Parceiros
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import "../assets/styles/iouu/mixins";

    .item {
        &{
            width: 100%;
            height: 100%;
            min-height: 500px;
        }

        &_tit {

            &{
                margin-bottom: 40px;
            }

            h1 {
                font-size: calcRem(50);
                font-weight: 300;
                padding-bottom: 20px;

                @include sm {
                    font-size: calcRem(40);
                }

                @include xs {
                    font-size: calcRem(30);
                }
            }

            p {
                font-size: calcRem(22);
                color: #666;

                @include xs {
                    font-size: calcRem(18);
                }
            }
        }

        ul {
            li {

                &{

                    &:nth-child(1) {
                        animation-duration: .8s;
                        animation-delay: 1.4s
                    }

                    &:nth-child(2) {
                        animation-duration: .8s;
                        animation-delay: 1.6s
                    }

                    &:nth-child(3) {
                        animation-duration: .8s;
                        animation-delay: 1.8s
                    }

                    @include sm {
                        padding-bottom: 1rem;
                    }

                    @include xs {
                        padding-bottom: 1rem;
                    }
                }

                a {
                    &{
                        border: 1px solid #bbb;
                        border-radius: 5px;
                        width: 100%;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        text-align: center;
                        flex-direction: column;
                        height: 65px;
                        background: #fff;
                        text-transform: uppercase;
                        font-weight: bold;
                        color: #999;
                    }

                    &:hover {
                        border: 3px solid #41d3bd;
                        color: #41d3bd;
                    }
                }
            }
        }
    }
</style>

<script>
// import ApiClient from '../utils/api-client';

export default {
  data() {
      return {

      }
  },
  methods: {
      Name() {
          var 
            nome        = "",
            firstName; 

            if(this.User.name == undefined || this.User.name == null || this.User.name == "") {
                nome = this.User.username;
            }  else {
                nome = this.User.name;
            }

            nome = nome.trim();
            firstName = nome.split(" ");

            return firstName[0];
        },
        //tagueamento GA
        taggingGA() {
            this.$ga.page({
                page: '/informacoes-adicionais/selecionar-area',
                title: 'Seleceionar area',
            })
        },
    }, 
    computed: {
        User: function() {
            return this.$store.state.currentUser;
        }
    },

    async created() {
        //tagueamento GA
        await this.taggingGA();
    }
}
</script>



// WEBPACK FOOTER //
// src/views/SelectArea.vue